<template>
  <div class="panel-card" style="flex:1">
    <el-tabs v-model="localCollectType" @tab-click="handleTabClick" class="collect-tabs">
      <el-tab-pane label="全部" name=""></el-tab-pane>
      <el-tab-pane label="常用" name="1001"></el-tab-pane>
      <el-tab-pane label="无码" name="2002"></el-tab-pane>
      <el-tab-pane label="散称" name="3003"></el-tab-pane>
    </el-tabs>
    <div class="shortcut-grid">
      <div
        v-for="(item, index) in collectedProducts"
        :key="index"
        class="shortcut-btn"
        @click="handleClick(item)"
      >
        <el-image
          v-if="item.coverPhoto"
          :src="item.coverPhoto"
          style="width: 40px; height: 40px; border-radius: 4px; object-fit: cover;"
          fit="cover"
        >
          <div slot="error" class="image-slot">
            <i :class="item.icon" style="font-size:1.5rem"></i>
          </div>
        </el-image>
        <i v-else :class="item.icon" style="font-size:1.5rem"></i>
        <span style="font-size:0.85rem">{{ item.name }}</span>
      </div>
      <div class="shortcut-btn add-btn" @click="handleAdd">
        <i class="el-icon-plus"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { queryStaffCollectedProduct } from '@/api/goods/staffCollectedProductApi'
import { getUserInfo } from '@/api/user/indexApi'
import { getShopId } from '@/api/shop/shopApi'
import { queryProductAndSpec } from '@/api/goods/productApi'

export default {
  name: 'ShortcutPanel',
  props: {
    collectType: {
      type: String,
      default: '' // 默认显示全部
    }
  },
  data() {
    return {
      collectedProducts: [],
      localCollectType: '' // 默认显示全部
    }
  },
  watch: {
    collectType: {
      immediate: true,
      handler(newVal) {
        if (newVal !== undefined) {
          this.localCollectType = newVal
        }
        this.loadCollectedProducts()
      }
    },
    localCollectType: {
      handler() {
        this.loadCollectedProducts()
      }
    }
  },
  mounted() {
    if (this.collectType !== undefined) {
      this.localCollectType = this.collectType
    }
    this.loadCollectedProducts()
  },
  methods: {
    async loadCollectedProducts() {
      try {
        const shopId = getShopId()
        if (!shopId) {
          this.collectedProducts = []
          return
        }
        
        const user = await getUserInfo()
        const staffId = user.userId || ''
        
        if (!staffId) {
          this.collectedProducts = []
          return
        }
        
        const params = {
          shopId: shopId,
          staffId: staffId,
          statusCd: '0',
          page: 1,
          row: 100
        }
        
        // 如果选择了具体类型，才传 collectType
        if (this.localCollectType) {
          params.collectType = this.localCollectType
        }
        
        const res = await queryStaffCollectedProduct(params)
        if (res.data && res.data.length > 0) {
          this.collectedProducts = res.data.map(item => ({
            id: item.valueId || item.productId,
            productId: item.productId,
            valueId: item.valueId,
            name: item.prodName || '',
            specName: item.specName || '',
            barCode: item.barCode || '',
            coverPhoto: item.coverPhoto || '',
            icon: this.getProductIcon(item.collectType),
            type: 'collected',
            collectedProduct: item
          }))
        } else {
          this.collectedProducts = []
        }
      } catch (error) {
        console.error('加载收藏商品失败:', error)
        this.collectedProducts = []
      }
    },
    getProductIcon(collectType) {
      const iconMap = {
        '1001': 'el-icon-star-on', // 常用
        '2002': 'el-icon-coin', // 无码
        '3003': 'el-icon-present' // 散称
      }
      return iconMap[collectType] || 'el-icon-goods'
    },
    async handleClick(item) {
      try {
        // 先查询商品信息
        const shopId = getShopId()
        if (!shopId) {
          this.$message.warning('店铺信息不存在')
          return
        }
        
        const params = {
          shopId: shopId,
          productId: item.productId,
          valueId: item.valueId,
          page: 1,
          row: 1
        }
        
        const res = await queryProductAndSpec(params)
        
        // 合并查询到的商品信息
        let productInfo = { ...item }
        
        if (res.data && res.data.length > 0) {
          const product = res.data[0]
          // 合并商品信息，优先使用查询到的信息
          productInfo = {
            ...item,
            productId: product.productId || item.productId,
            valueId: product.valueId || item.valueId,
            name: product.prodName || item.name,
            specName: product.specName || item.specName,
            barCode: product.barCode || item.barCode,
            coverPhoto: product.coverPhoto || item.coverPhoto,
            price: parseFloat(product.prodPrice || 0),
            vipPrice: parseFloat(product.vipPrice || 0),
            // 保留其他商品详情信息
            ...product
          }
        }
        
        // 触发查询商品详情事件，传递合并后的商品信息
        this.$emit('add-collected-product', productInfo)
      } catch (error) {
        console.error('查询商品信息失败:', error)
        this.$message.error('查询商品信息失败')
        // 如果查询失败，仍然传递原始信息
        this.$emit('add-collected-product', item)
      }
    },
    handleAdd() {
      // 跳转到收藏商品管理页面
      this.$router.push('/views/goods/staffCollectedProduct')
    },
    handleTabClick(tab) {
      this.localCollectType = tab.name
      this.$emit('type-change', this.localCollectType)
    },
    refresh() {
      this.loadCollectedProducts()
    }
  }
}
</script>

<style scoped>
.panel-card {
  background: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  display: flex;
  flex-direction: column;
}

.card-header {
  font-weight: bold;
  padding-bottom: 8px;
  margin-bottom: 10px;
  color: #475569;
  font-size: 0.95rem;
  display: block;
}

.collect-tabs {
  margin-bottom: 10px;
  border-bottom: 1px solid #f1f5f9;
}

.collect-tabs >>> .el-tabs__header {
  margin: 0;
}

.collect-tabs >>> .el-tabs__nav-wrap::after {
  display: none;
}

.collect-tabs >>> .el-tabs__item {
  padding: 0 15px;
  height: 32px;
  line-height: 32px;
  font-size: 0.85rem;
}

.shortcut-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.shortcut-btn {
  background: white;
  border: 1px solid #cbd5e1;
  padding: 15px 5px;
  text-align: center;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  transition: all 0.2s;
  min-height: 75px;
  justify-content: center;
  font-size: 0.9rem;
}

.shortcut-btn:hover {
  border-color: #2563eb;
  color: #2563eb;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0,0,0,0.05);
}

.shortcut-btn.add-btn {
  border-style: dashed;
  color: #94a3b8;
  font-size: 1.5rem;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
}
</style>

